import React, { useState } from 'react'
import { isNewUser } from 'utility/user-check'
import { AuthService } from 'utility/services/auth'
import { CustomerService } from 'utility/services/customer'
import { PageHeader } from 'components'
import { AppPrimaryButton } from 'elements'

export const TestNewUserScreen = () => {
    const [result, setResult] = useState(null)
    const [loading, setLoading] = useState(false)

    const testIsNewUser = async () => {
        setLoading(true)
        setResult(null)
        try {
            console.log('=== TESTING isNewUser FUNCTION ===')
            const user = AuthService.getUser()
            console.log('User object:', user)
            console.log('User.CompanyId:', user?.CompanyId)
            console.log('User.Companies:', user?.Companies)
            console.log('User.Companies[0]:', user?.Companies?.[0])
            console.log('User.Companies[0].CompanyId:', user?.Companies?.[0]?.CompanyId)

            const companyId = user?.CompanyId || user?.Companies?.[0]?.CompanyId
            console.log('Final CompanyId:', companyId)

            const customerResult = await CustomerService.list({
                CallFrom: 1,
                PageNumber: 1,
                PageSize: 10,
            })
            console.log('Customer API result:', customerResult)
            console.log('Customer Items:', customerResult.Items)
            console.log('Customer Items length:', customerResult.Items?.length)

            const isNew = await isNewUser()
            console.log('isNewUser result:', isNew)

            setResult({
                user,
                companyId,
                customerResult,
                isNew,
            })
        } catch (error) {
            console.error('Error testing isNewUser:', error)
            setResult({ error: error.message })
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="test-new-user-screen px-4 py-6 max-w-4xl mx-auto">
            <PageHeader header="Test New User Detection" />

            <div className="mt-6">
                <AppPrimaryButton onClick={testIsNewUser} loading={loading}>
                    Test isNewUser Function
                </AppPrimaryButton>

                {result && (
                    <div className="mt-6 bg-white rounded-lg shadow-md p-6">
                        <h3 className="text-lg font-medium mb-4">Test Results:</h3>
                        <div className="space-y-2">
                            <div>
                                <strong>CompanyId:</strong> {result.companyId || 'Not found'}
                            </div>
                            <div>
                                <strong>Customer Count:</strong> {result.customerResult?.Items?.length || 0}
                            </div>
                            <div>
                                <strong>Is New User:</strong>{' '}
                                <span className={result.isNew ? 'text-green-600' : 'text-red-600'}>
                                    {result.isNew ? 'YES ✓' : 'NO ✗'}
                                </span>
                            </div>
                            {result.error && (
                                <div className="text-red-600">
                                    <strong>Error:</strong> {result.error}
                                </div>
                            )}
                        </div>

                        <div className="mt-4 p-4 bg-gray-100 rounded">
                            <h4 className="font-medium mb-2">User Object:</h4>
                            <pre className="text-xs overflow-auto">
                                {JSON.stringify(result.user, null, 2)}
                            </pre>
                        </div>

                        <div className="mt-4 p-4 bg-gray-100 rounded">
                            <h4 className="font-medium mb-2">Customer API Response:</h4>
                            <pre className="text-xs overflow-auto">
                                {JSON.stringify(result.customerResult, null, 2)}
                            </pre>
                        </div>
                    </div>
                )}
            </div>

            <div className="mt-6 text-sm text-gray-600">
                <p>
                    <strong>Instructions:</strong>
                </p>
                <ol className="list-decimal list-inside mt-2 space-y-1">
                    <li>Click the "Test isNewUser Function" button</li>
                    <li>Check the console for detailed logs</li>
                    <li>Review the results above</li>
                    <li>For a new user, "Is New User" should be YES</li>
                </ol>
            </div>
        </div>
    )
}

export default TestNewUserScreen
